import Bloc from './Bloc.js';
import Types from './Types.js';

export default class RunAway extends Bloc {

	constructor (src, ctx) {

		super("runaway", src, ctx, true);
		this.f = (src, ins) => {
			src.master.runAway();
			return [];
		};
		this.types = [];
	}
}